const AccountBalancesList = () => import('../screens/AccountBalances/List/AccountBalancesList.vue');

export default [
  {
    component: AccountBalancesList,
    meta: {
      activeSidebarItemId: 'account-balances',
      authority: 'account_balances:view',
      pageTitle: 'Account Balances',
    },
    name: 'account-balances',
    path: '/account-balances',
  },
];
